// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__NEez0","title":"FrontImage_title__2zn5X"};